module.exports = __webpack_public_path__ + "media/images/flags/ku-41603a83ee445b984001546d6bb0dea0.svg";